<template>
  <div class="flex flex-col min-h-screen bg-white">
    <Header/>
    <router-view class="flex-grow"></router-view>
    <Footer/>
  </div>
</template>

<script>
import Header from './components/HeaderGlobal.vue';
import Footer from './components/FooterGlobal.vue';

export default {
  components: {
    Header,
    Footer
  }
}
</script>